import { PermissionType } from '@application/common/enums/role-permission';
import moment from 'moment';
import LocalStorageService from './local-storage-service';
export const convertModelToFormData = (data, form = new FormData(), namespace = '') => {
    let files = {};
    let model = {};
    for (let propertyName in data) {
        if (!data.hasOwnProperty(propertyName) || !data[propertyName])
            continue;
        if (data[propertyName] instanceof Array) {
            if (data[propertyName].every((x) => x instanceof File)) {
                files[propertyName] = data[propertyName];
            }
            else {
                model[propertyName] = data[propertyName];
            }
        }
        else if (data[propertyName] instanceof File || data[propertyName]) {
            files[propertyName] = data[propertyName];
        }
        else {
            model[propertyName] = data[propertyName];
        }
    }
    let formData = form || new FormData();
    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName])
            continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date)
            formData.append(formKey, model[propertyName].toISOString());
        else if (model[propertyName] instanceof File) {
            formData.append(formKey, model[propertyName]);
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === 'object')
                    convertModelToFormData(element, formData, tempFormKey);
                else
                    formData.append(tempFormKey, element.toString());
            });
        }
        else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            convertModelToFormData(model[propertyName], formData, formKey);
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    for (let propertyName in files) {
        if (files.hasOwnProperty(propertyName)) {
            if (files[propertyName] instanceof Array) {
                files[propertyName].forEach((element) => {
                    formData.append(propertyName, element);
                });
            }
            else
                formData.append(propertyName, files[propertyName]);
        }
    }
    return formData;
};
export const convertModelToFormDataWithList = (data, form = new FormData(), namespace = '') => {
    let formData = form || new FormData();
    for (let propertyName in data) {
        if (!data.hasOwnProperty(propertyName) || data[propertyName] == null)
            continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (data[propertyName] instanceof Date) {
            formData.append(formKey, data[propertyName].toISOString());
        }
        else if (data[propertyName] instanceof File) {
            formData.append(formKey, data[propertyName]);
        }
        else if (data[propertyName] instanceof Array) {
            data[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === 'object' && !(element instanceof File)) {
                    convertModelToFormDataWithList(element, formData, tempFormKey);
                }
                else {
                    formData.append(tempFormKey, element.toString());
                }
            });
        }
        else if (typeof data[propertyName] === 'object' && !(data[propertyName] instanceof File)) {
            convertModelToFormDataWithList(data[propertyName], formData, formKey);
        }
        else {
            formData.append(formKey, data[propertyName].toString());
        }
    }
    return formData;
};
export const convertDateTime = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('YYYY-MM-DD');
    return '';
};
export const formatDMY = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('DD-MM-YYYY');
    return '';
};
export const formatDateDMY = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('DD-MM-YYYY');
    return '';
};
export const formatMDY = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('MM-DD-YYYY');
    return '';
};
export const formatYMD = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('YYYY-MM-DD');
    return '';
};
export const getCurrentISOformatDMY = () => {
    const formattedDate = new Date();
    const day = formattedDate.getUTCDate().toString().padStart(2, '0');
    const month = (formattedDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = formattedDate.getUTCFullYear();
    return `${day}-${month}-${year}`;
};
export const getDateTimeStemp = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('YYYYMMDD HHmmSS');
    return '';
};
export const getDateFormat = (date) => {
    return moment(date).format('DDMMYYYY');
};
export const getLocalDateTime = (date) => {
    if (date !== null && date !== undefined) {
        const dateWithTime = date ? new Date(date) : new Date();
        const localTime = new Date().toLocaleTimeString();
        const localDateTime = `${dateWithTime.toLocaleDateString()} ${localTime}`;
        return new Date(localDateTime);
    }
    return new Date();
};
export const getDutchDateFormat = (date) => {
    const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    };
    if (date !== null && date !== undefined) {
        const formattedDate = new Intl.DateTimeFormat('nl-NL', options).format(date);
        const parts = formattedDate.split(' ');
        const formattedDateString = parts[0] + ', ' + parts[2] + ' ' + parts[1] + ', ' + parts[3];
        return formattedDateString;
    }
    return '';
};
export const handleRolePermission = (permission, permissionType) => {
    let currentRolePermissions = LocalStorageService.getRolePermission();
    // let currentUserClaims = getCurrentUserFromJwt(LocalStorageService.getAccessToken()?? '')
    // if(currentUserClaims?.role === '1') {
    //     return true;
    // }
    if (!currentRolePermissions) {
        return false;
    }
    const hasPermission = currentRolePermissions.some((rp) => rp.permissionId === permission &&
        rp.isActive &&
        ((permissionType === PermissionType.Create && rp.create) ||
            (permissionType === PermissionType.Read && rp.read) ||
            (permissionType === PermissionType.Update && rp.update) ||
            (permissionType === PermissionType.Delete && rp.delete)));
    return hasPermission;
};
export const getDateWithoutTime = (date) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    const offset = date.getTimezoneOffset(); // Get timezone offset
    const adjustedDate = new Date(date.getTime() - offset * 60 * 1000); // Adjust for timezone
    return adjustedDate;
};
